import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-atencion-inmediata',
  templateUrl: './atencion-inmediata.component.html',
  styleUrls: ['./atencion-inmediata.component.css']
})
export class AtencionInmediataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
